import React, {useRef, useState, useEffect, useLayoutEffect} from 'react';

import Select from 'react-select';
import {Handle} from 'reactflow';

import {Chatbot} from '../../states/actions';
import {useSelector} from 'react-redux';
import {onEdit, onSetStart, onClose, onRemove, isLightColor} from '../../helpers/block-helper';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';
import {ckEditorBasic} from '../../config';
import {ColorPicker} from '../ColorPicker';
import {User} from '../../states/actions';
import logger from '../../utils/logger';
//import Buttons from 'react-multi-date-picker/components/button';

import {validations, moneyCurrency, ckEditorInputBlock} from '../../config';
import {InputComponent, SelectComp, ButtonState, onEdited, ButtonSwitch, blockIconSrc} from './Components'

import {DecisionEditor} from './DecisionBlock'
import {CalculationEditor} from './CalculationBlock'
import {ConditionEditor} from './ConditionBlock'
import {MultiplechoiceEditor} from './MultipleChoiceBlock'
import {ReviewEditor} from './ReviewBlock'
import {PaymentEditor} from './PaymentBlock'
import {DataEditor} from './DataBlock'
import {DocumentEditor} from './DocumentBlock'
import {EmailEditor} from './EmailBlock'
import {ShareEditor} from './ShareBlock'
import {UploadEditor} from './UploadBlock'
import {InputUploadEditor} from './InputUploadBlock'
import {TeleportEditor} from './TeleportBlock'
import {SheetEditor} from './SheetBlock'
import {MatchEditor} from './MatchBlock'
import {ClassifyEditor} from './ClassifyBlock'
import {MatchV2Editor} from './MatchV2Block'
import {MatchV2CopiesSection} from './MatchV2CopiesSection'
import {ScoroEditor} from './ScoroBlock'
import {AiEditor} from './AiBlock'
import {RouterEditor} from './RouterBlock'
import {LoginEditor} from './LoginBlock'
import {CalendarEditor} from './CalendarBlock'
import {ProjectEditor} from './ProjectBlock'
import {SubscriptionEditor } from './SubscriptionBlock';
import {SubscriptionCheckEditor} from './SubscriptionCheckBlock';
import {GTMEditor} from './GTMBlock';
import {InvoiceEditor} from './InvoiceBlock';

const WAIT_LADDER_BLOCK_TYPES = new Set([
  'matchV2Block',
  'aiBlock',
  'documentBlock',
  'invoiceBlock',
  'projectBlock',
  'calendarBlock',
  'sheetBlock',
  'uploadBlock',
  'inputuploadBlock',
]);

const WAIT_LADDER_THRESHOLDS_SEC = {
  matchV2Block: [8, 25],
  aiBlock: [8, 25],
  documentBlock: [8, 25],
  sheetBlock: [12, 30],
  invoiceBlock: [12, 30],
  projectBlock: [12, 30],
  calendarBlock: [12, 30],
  uploadBlock: [12, 30],
  inputuploadBlock: [12, 30],
};

export const BlockEditor = ({node, onUpdate}) => {

  const optionSelectRef = useRef(null);
  const bot = useSelector(Chatbot.get());
  const [routeSecondary, setRouteSecondary] = useState(false);
  const [language, setLanguage] = useState('default'); // Options: 'default', 'en', 'ru'


  const inputRef = React.useRef(null);
  const refTxtText = useRef(null);
  const refTxtValue = useRef(null);
  const [loaded, setLoaded] = useState(false);

  
  const block = Chatbot.getBlock(node);
  const {
    data,
    data: {decisions = {}, options ={}, reviews={}},
  } = block;


  const [contentvalue, setContentValue] = useState(data.content);
  const [contentHtmlValue, setContentHtmlValue] = useState(data.contentHtml ?? '');
  const [htmlEditorView, setHtmlEditorView] = useState('visual');
  const htmlVisualRef = useRef(null);
  const [notificationvalue, setNotificationValue] = useState(data.notification);
  const [disclaimervalue, setDisclaimerValue] = useState(data.disclaimer);
  const [modalvalue, setModalValue] = useState(data.modal);


  const [notification, showNotification] = useState(notificationvalue !== undefined && notificationvalue.length > 0 ? true : false);
  const [disclaimer, showDisclaimer] = useState(disclaimervalue !== undefined && disclaimervalue.length > 0 ? true : false);
  const [modal, showModal] = useState(data.modal !== undefined && data.modal.length > 0 ? true : false);


  useEffect(() => {
    const content = handleLocalizedValue('content');
    setContentValue(data[content] ?? '');
    const contentHtml = handleLocalizedValue('contentHtml');
    setContentHtmlValue(data[contentHtml] ?? '');
    const notification = handleLocalizedValue('notification');
    setNotificationValue(data[notification] ?? '');
    const disclaimer = handleLocalizedValue('disclaimer');
    setDisclaimerValue(data[disclaimer] ?? '');
    const modal = handleLocalizedValue('modal');
    setModalValue(data[modal] ?? '');

    const notifVal = data[notification];
    showNotification(typeof notifVal === 'string' && notifVal.length > 0);
    const disclaimerVal = data[disclaimer];
    showDisclaimer(typeof disclaimerVal === 'string' && disclaimerVal.length > 0);
    const modalVal = data[modal];
    showModal(typeof modalVal === 'string' && modalVal.length > 0);
  }, [
    language,
    data.content,
    data.content_en,
    data.content_ru,
    data.contentHtml,
    data.contentHtml_en,
    data.contentHtml_ru,
    data.notification,
    data.notification_en,
    data.notification_ru,
    data.disclaimer,
    data.disclaimer_en,
    data.disclaimer_ru,
    data.modal,
    data.modal_en,
    data.modal_ru,
    data.messageDisplayMode,
    data.messageDisplayMode_en,
    data.messageDisplayMode_ru,
    data.subject,
    data.subject_en,
    data.subject_ru,
    data.waitmessage,
    data.waitmessage_en,
    data.waitmessage_ru,
    data.waitmessage2,
    data.waitmessage2_en,
    data.waitmessage2_ru,
    data.waitmessage3,
    data.waitmessage3_en,
    data.waitmessage3_ru,
  ]);

  useLayoutEffect(() => {
    if (
      !block ||
      (block.type !== 'textBlock' &&
        block.type !== 'decisionBlock' &&
        block.type !== 'emailBlock' &&
        block.type !== 'inputBlock' &&
        block.type !== 'inputuploadBlock')
    ) return;
    const d = block.data;
    const eff = d.messageDisplayMode ?? 'message';
    if (eff !== 'html' || htmlEditorView !== 'visual') return;
    const el = htmlVisualRef.current;
    if (!el) return;
    if (document.activeElement === el) return;
    const html = contentHtmlValue ?? '';
    if (el.innerHTML !== html) el.innerHTML = html;
  }, [block, language, htmlEditorView, contentHtmlValue, loaded]);

  useEffect(() => {
    const htmlBodyBlockTypes = new Set([
      'textBlock',
      'decisionBlock',
      'emailBlock',
      'inputBlock',
      'inputuploadBlock',
    ]);

    window.flushVisualHtml = () => {
      if (!block || !htmlBodyBlockTypes.has(block.type)) return;
      const eff = block.data.messageDisplayMode ?? 'message';
      if (eff !== 'html' || htmlEditorView !== 'visual') return;
      const el = htmlVisualRef.current;
      if (!el) return;
      const field =
        language === 'en' ? 'contentHtml_en' : language === 'ru' ? 'contentHtml_ru' : 'contentHtml';
      Chatbot.setBlockData(block.id, {[field]: el.innerHTML});
    };

    return () => {
      delete window.flushVisualHtml;
    };
  }, [block, language, htmlEditorView]);

  const {_id} = useSelector(User.get());



  //Use this to give time to load components with new data. 
  //This is not the best approach.
  useEffect(() => {
    setTimeout(() => {
     setLoaded(true)
    }, "1")
   }, [block]);
  
  const variableOptions = Chatbot.getBlockVariables();

  let variables_inputtype = [
    {
      label: 'Input',
      value: 'input',
      content: 'input',
    },
    {
      label: 'Textarea',
      value: 'textarea',
      content: 'textarea',
    },
    {
      label: 'Signature',
      value: 'signature',
      content: 'signature',
    },
  ];


  if (!block) {
        return null;
  }

  const decisionDisplayMode = data.displayMode || (data.isChoices ? 'choices' : 'buttons');
  const decisionRouteCount = Object.values(decisions).length;
  const decisionNeedsSubmitButton =
    block.type === 'decisionBlock' &&
    (decisionRouteCount > 2 ||
      decisionDisplayMode === 'choices' ||
      decisionDisplayMode === 'html');

  const contentDisplayMode = data.messageDisplayMode ?? 'message';
  const textBodyIsHtmlMode =
    (block.type === 'textBlock' ||
      block.type === 'decisionBlock' ||
      block.type === 'emailBlock' ||
      block.type === 'inputBlock' ||
      block.type === 'inputuploadBlock') &&
    contentDisplayMode === 'html';

  // Handler to change language
  const handleLanguageChange = (newLanguage) => {
    logger.log(newLanguage)
    setLanguage(newLanguage);
  };


 
 const handleBlur = (e) => {   
  //e.preventDefault();s
  //logger.log("blur", e.target.name)
  //saveData(block.id, e.target.name, e.target.value, e.target);
  Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
 };

 const handleBlurContent = (data, content) => {   
  const content_local = handleLocalizedValue(content)
  Chatbot.setBlockData(block.id, {[content_local]: data});
 };

 
 const handleLocalizedValue = (value) => {   
  const value_local = language === 'en' ? value +`_en` : language === 'ru' ? value + `_ru` : value;
  return value_local
};


function EditorHeader() {
  const isInputUpload = data.type === 'inputupload';
  return (
          <>
           <div className="editor-header">

           <i className="me-3" style={isInputUpload ? {display: 'flex', alignItems: 'center', gap: 6} : undefined}>
             {isInputUpload ? (
               <>
                 <img src="/images/icons/input.png" alt="" />
                 <img src="/images/icons/upload.png" alt="" />
               </>
             ) : (
               <img src={blockIconSrc(data.type)} alt="" />
             )}
           </i>
              <span className='float-right'>

              
          
              {(block.type === "inputBlock" || block.type === "textBlock" || block.type === "decisionBlock" || block.type === "multipleChoiceBlock" || block.type === "paymentBlock" || block.type === "subscriptionBlock" ||  block.type === "uploadBlock" || block.type === "inputuploadBlock" || block.type === "loginBlock" || block.type === "matchBlock" || block.type === "matchV2Block" || block.type === "emailBlock" || block.type === "calendarBlock" || block.type === "aiBlock" || block.type === "documentBlock" || block.type === "scoroBlock")  &&(

                  <>
                    <i className={`mx-1 btn-circle ${language === 'default' ? 'active' : ''}`}  onClick={() => handleLanguageChange('default')}> et </i>
                    <i className={`mx-1 btn-circle ${language === 'en' ? 'active' : ''}`}  onClick={() => handleLanguageChange('en')}> en </i>
                    <i className={`mx-1 btn-circle ${language === 'ru' ? 'active' : ''}`}  onClick={() => handleLanguageChange('ru')}> ru </i>
                  </>

              )}

              <i className="mx-1 badge bg-success" style={{cursor: 'pointer'}} onClick={() => {onSetStart(node); onEdited()}}>
                Set home
              </i>
              
              <i 
                className={`mx-1 badge ${data.disableHistory ? 'bg-success' : 'bg-secondary'}`}
                style={{cursor: 'pointer'}}
                onClick={() => {
                  const newValue = !(data.disableHistory === true);
                  Chatbot.setBlockData(node, {disableHistory: newValue}, true);
                  onEdited();
                }}
                title={data.disableHistory ? 'History disabled - Click to enable' : 'History enabled - Click to disable'}
              >
                <i className={`fa fa-${data.disableHistory ? 'lock' : 'unlock'}`}></i>
              </i>
             {/*  <i className="mx-1 badge bg-danger" onClick={() => onRemove(node)}>
                Remove
              </i>

              <i
                className="ms-1 me-2 icon fa fa-times"
                onClick={() => onClose(node)}
              ></i> */}
              </span>
              </div>
          </>
  );
}

/* function Button() {
  return (
          <>

          <InputComponent data={data} name="Button name" dataname="buttontext" onBlur={handleBlur}/>

          <InputComponent data={data} name="Validation Message" dataname="validationMessage" onBlur={handleBlur}/>

          {block.type === 'textBlock' ? (
              <Buttonstate/>
              ):(<></>)}
          </>
  );
} */
/* 
function Buttonstate(block, label) {    

    //const [buttonstate, setButtonState] = useState(data[dataname]);

    function setActive(e){
      const state = buttonstate ? false : true;
      setButtonState(state); 
      Chatbot.setBlockData(block.id, {button: state}) 
   }

  return (
      <>


        <div className='btn-switch' onClick={(e) => {setActive(e)}}>
              <div  
                    className={`switch ${buttonstate ? 'on' : 'off'}`}>
                    <span></span>
               </div>
              <span className='text'>{label}</span>
        </div>
       
      </> 
  )
} 
*/

/* Not using atm because translation management needs to update content of modal, but when using component then content does not updated correclty yet. TODO later.*/
function Modal() {   

  if(data.modal !== undefined){
    if(data.modal.length > 0){showModal(true)} 
  }
  return (
    <>
    
    {!modal &&
    <div className="mb-2 mt-2 pointer link" onClick={()=> {showModal(modal ? false : true, modal ? true : false)}}> + Modal</div>  
    }
    {modal && (
      <>
        <br/>
        <div>

        <InputComponent data={data} name="Modal" placeholder="Link name" dataname={ language === 'en' ? `modallink_en` : language === 'ru' ? `modallink_ru` : `modallink`} language={language}  onBlur={handleBlur}/>

         <div id="modal">
            <CKEditor
              config={ckEditorBasic}
              editor={ClassicEditor}
              onChange={onEdited}
              data={modalvalue}
              onBlur={(e, editor) => {
                handleBlurContent(editor.getData(), 'modal');
              }}

            />
          </div>
          </div>
      </> 
      )}
      </>
  )
}



const SecondButton = () => {

  if(data.secondbutton !== undefined){
    if(data.secondbutton.length > 0){setRouteSecondary(true)} 
  } 
  return (
    <>
    {!routeSecondary && 
      <div className="mb-2 mt-2 pointer link" onClick={()=> {
        const state = routeSecondary ? false : true ? true : false;
        setRouteSecondary(state)
        if(!state){
        Chatbot.setBlockData(block.id, {next_secondary : ""})
        }
      }
      }> + Add Route</div>
    }
   
    </> 
  )
}


  





return (

       <>
            
              <EditorHeader/>
              {loaded &&(
              <div className='content'>

                 

                  {/* message */}
                  {(block.type === "commentBlock") && (
                          <div className="mb-2">
                          <label className="form-label comp-header">
                           Comment<i></i>
                          </label>
                        <div id="content">
                          <CKEditor
                            onReady={(editor) => {
                              /* editor.editing.view.change((writer) => {
                                writer.setStyle('height', '100px', editor.editing.view.document.getRoot());
                              }); */
                            }}
                            config={
                              {
                                toolbar: ['bold', 'italic', 'link', 'ctaButton', 'insertImage'],
                                link: {
                                  // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                                  addTargetToExternalLinks: true,
                                },
                              simpleUpload: {
                                uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                              }
                              }
                          }
                            onChange={onEdited}
                            editor={ClassicEditor}
                            data={data.content}
                            onBlur={(e, editor) => {
                              Chatbot.setBlockData(block.id, {content: editor.getData()});
                            }}
                          />
                        </div>
                          
                      </div>
                  )}

                  {(block.type === "inputBlock" || block.type === "textBlock" || block.type === "decisionBlock" || block.type === "multipleChoiceBlock" || block.type === "reviewBlock" || block.type === "paymentBlock" || block.type === "subscriptionBlock" || block.type === "shareBlock" || block.type === "uploadBlock" || block.type === "inputuploadBlock" || block.type === "loginBlock" || block.type === "matchBlock" || block.type === "matchV2Block")  &&(
                        
                        <>
                        <br/> <br/>

                        <InputComponent data={data} name="Message" dataname={ language === 'en' ? `headtext_en` : language === 'ru' ? `headtext_ru` : `headtext`} language={language} onBlur={handleBlur}/>

                        {(block.type === 'textBlock' ||
                          block.type === 'decisionBlock' ||
                          block.type === 'inputBlock' ||
                          block.type === 'inputuploadBlock') && (
                          <div className="section section--with-control">
                            <span>CONTENT DISPLAY MODE</span>
                            <div
                              className="btn-switch"
                              onClick={() => {
                                if (contentDisplayMode === 'html') {
                                  Chatbot.setBlockData(block.id, {messageDisplayMode: 'message'});
                                  onEdited();
                                  return;
                                }
                                const htmlBodyField = handleLocalizedValue('contentHtml');
                                const richField = handleLocalizedValue('content');
                                const patch = {messageDisplayMode: 'html'};
                                const curHtml = data[htmlBodyField];
                                const curRich = data[richField];
                                if (
                                  (!curHtml || String(curHtml).trim() === '') &&
                                  curRich &&
                                  String(curRich).trim() !== ''
                                ) {
                                  patch[htmlBodyField] = curRich;
                                }
                                Chatbot.setBlockData(block.id, patch);
                                onEdited();
                              }}
                            >
                              <div
                                className={`switch ${contentDisplayMode === 'html' ? 'on' : 'off'}`}
                              >
                                <span />
                              </div>
                              <span className="text">HTML</span>
                            </div>
                          </div>
                        )}

                         

                        {/* contnent message */}
                        <div>
                          <div id="content">
                            {textBodyIsHtmlMode ? (
                              <>
                                <div className="mode-selector" style={{display: 'flex', gap: '8px', marginBottom: '10px', marginTop: '8px'}}>
                                  {['source', 'visual'].map((view) => (
                                    <span
                                      key={view}
                                      className={`mode-pill ${htmlEditorView === view ? 'active' : ''}`}
                                      style={{
                                        padding: '6px 12px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                        cursor: 'pointer',
                                        backgroundColor: htmlEditorView === view ? '#032097' : '#f0f0f0',
                                        color: htmlEditorView === view ? 'white' : '#000',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        textTransform: 'capitalize',
                                      }}
                                      onClick={() => {
                                        if (view === 'source' && htmlEditorView === 'visual' && htmlVisualRef.current) {
                                          handleBlurContent(htmlVisualRef.current.innerHTML, 'contentHtml');
                                        }
                                        setHtmlEditorView(view);
                                        onEdited();
                                      }}
                                    >
                                      {view}
                                    </span>
                                  ))}
                                </div>
                                {htmlEditorView === 'source' ? (
                                  <textarea
                                    key={`${block.id}-html-src-${language}`}
                                    className="form-control"
                                    rows={6}
                                    placeholder="HTML content"
                                    defaultValue={contentHtmlValue ?? ''}
                                    onChange={onEdited}
                                    onBlur={(e) => {
                                      handleBlurContent(e.target.value, 'contentHtml');
                                    }}
                                  />
                                ) : (
                                  <div
                                    ref={htmlVisualRef}
                                    className="form-control"
                                    contentEditable
                                    suppressContentEditableWarning
                                    onInput={() => onEdited()}
                                    onBlur={(e) => {
                                      handleBlurContent(e.currentTarget.innerHTML, 'contentHtml');
                                    }}
                                    style={{
                                      minHeight: '120px',
                                      overflow: 'auto',
                                      textAlign: 'left',
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                            <CKEditor
                              onReady={(editor) => {
                                /* editor.editing.view.change((writer) => {
                                  writer.setStyle('height', '100px', editor.editing.view.document.getRoot());
                                }); */
                              }}
                              config={
                                {
                                  toolbar: ['bold', 'italic', 'link', 'ctaButton', 'insertImage'],
                                  link: {
                                    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                                    addTargetToExternalLinks: true,
                                  },
                                simpleUpload: {
                                  uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                                }
                                }
                            }
                              onChange={onEdited}
                              editor={ClassicEditor}
                              data={contentvalue}
                              onBlur={(e, editor) => {
                                handleBlurContent(editor.getData(), 'content');
                              }}
                            />
                            )}
                          </div>
                            
                        </div>


                        {!notification &&
                        <div className="mb-2 mt-2 pointer link" onClick={()=> {showNotification(notification ? false : true, notification ? true : false)}}> + Notification</div>
                         } 
                         {notification && (
                              <>
                                  <br/>

                                <div>
                                        <label htmlFor="notification" className="form-label comp-header">
                                          Notification
                                        </label>
                                        <div id="notification">
                                          <CKEditor
                                            config={ckEditorBasic}
                                            editor={ClassicEditor}
                                            onChange={onEdited}

                                            data={notificationvalue}
                                            onBlur={(e, editor) => {
                                              handleBlurContent(editor.getData(), 'notification');
                                            }}

                                          />
                                        </div>
                                      </div>
                              </>
                        )} 
                          
    
                         {!modal &&
                        <div className="mb-2 mt-2 pointer link" onClick={()=> {showModal(modal ? false : true, modal ? true : false)}}> + Modal</div>  
                         }                      
                        {modal && (
                            <>
                              <br/>
                              <div>

                              <InputComponent data={data} name="Modal" placeholder="Link name" dataname={ language === 'en' ? `modallink_en` : language === 'ru' ? `modallink_ru` : `modallink`} language={language}  onBlur={handleBlur}/>

                              <div id="modal">
                                  <CKEditor
                                    //config={ckEditorBasic}
                                    config={
                                      {
                                        toolbar: ['bold', 'italic', 'link', 'insertImage'],
                                        link: {
                                          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                                          addTargetToExternalLinks: true,
                                        },
                                      simpleUpload: {
                                        uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                                      }
                                      }
                                  }
                                    editor={ClassicEditor}
                                    onChange={onEdited}
                                    data={modalvalue}
                                    onBlur={(e, editor) => {
                                      handleBlurContent(editor.getData(), 'modal');
                                    }}

                                  />
                                </div>
                                </div>
                            </> 
                            )}
                                                  
      
                       {/*  <Modal/> */}
                        
                      </>
                  )}
                  




                  {block.type === "inputBlock" &&(
                    <>
                    <div className='section'>INPUT</div>

                    <SelectComp data={data} name="Input type" dataname="inputtype" options={variables_inputtype} block={block}/>
                    

                    {/* select input type */}
                   {/*  <ButtonSwitch name="Input type" block={block} data={data} dataname="inputtype" label1="" label2="Long input" state1="input" state2="textarea"/> */}

                   <InputComponent data={data} name="Character limit" dataname="characterlimit" onBlur={handleBlur}/>

                    <SelectComp data={data} name="Validation Rule" dataname="validation" placeholder="Select validation rule" options={validations} block={block}/>

                    {data.validation === 'custom' && (
                     <InputComponent data={data} name="Custom rule" dataname="customrule" onBlur={handleBlur}/>
                    )}

                    {data.validation === 'money' && (
                      <SelectComp data={data} name="Choose Currency" dataname="currency" placeholder="Choose currency" options={moneyCurrency} block={block}/>
                    )}

                    <br/><br/><br/>
                    
                    <InputComponent data={data} name="Input name" dataname={ language === 'en' ? `inputname_en` : language === 'ru' ? `inputname_ru` : `inputname`} language={language} onBlur={handleBlur}/>

                    <InputComponent data={data} name="Hint message" dataname={ language === 'en' ? `hint_en` : language === 'ru' ? `hint_ru` : `hint`} language={language} onBlur={handleBlur}/>


                    </>
                  )}

                  {block.type === "calculationBlock" &&(
                    <CalculationEditor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "conditionBlock" &&(
                    <ConditionEditor nodeid={node} block={block} data={data} />
                  )}

                   {block.type === "dataBlock" &&(
                    <DataEditor nodeid={node} block={block} data={data} />
                  )}

                  {block.type === "teleportBlock" &&(
                    <TeleportEditor nodeid={node} block={block} data={data} reviews={reviews} variableoptions={variableOptions} />
                  )}
                  
                  {block.type === "decisionBlock" && language &&(
                    <DecisionEditor nodeid={node} block={block} data={data} decisions={decisions} language={language} />
                  )}

                  {block.type === "multipleChoiceBlock" &&(
                    <>
                      <InputComponent data={data} name="Input name" dataname={ language === 'en' ? `inputname_en` : language === 'ru' ? `inputname_ru` : `inputname`} language={language} onBlur={handleBlur}/>

                      <MultiplechoiceEditor nodeid={node} block={block} data={data} options={options} />
                    </>
                  )}

                  {block.type === "reviewBlock" &&(
                    <ReviewEditor nodeid={node} block={block} data={data} reviews={reviews} />
                  )}

                  {block.type === "shareBlock" &&(
                    <ShareEditor nodeid={node} block={block} data={data} reviews={reviews} />
                  )}
                  
                 {block.type === "uploadBlock" &&(
                    <UploadEditor nodeid={node} block={block} data={data} reviews={reviews} />
                  )}

                  {block.type === "inputuploadBlock" &&(
                    <InputUploadEditor nodeid={node} block={block} data={data} variableoptions={variableOptions} language={language} />
                  )}

                  {block.type === "paymentBlock" &&(
                    <PaymentEditor nodeid={node} block={block} data={data} variableoptions={variableOptions}/>
                  )}

                  {block.type === "subscriptionBlock" &&(
                    <SubscriptionEditor nodeid={node} block={block} data={data} variableoptions={variableOptions}/>
                  )}

                  {block.type === "subscriptioncheckBlock" &&(
                    <SubscriptionCheckEditor />
                  )}

                  {block.type === "gtmBlock" &&(
                    <GTMEditor nodeid={node} block={block} data={data} />
                  )}

                  {block.type === "invoiceBlock" &&(
                    <InvoiceEditor nodeid={node} block={block} data={data} variableoptions={variableOptions}/>
                  )}

                  {block.type === "scoroBlock" &&(
                    <ScoroEditor nodeid={node} block={block} data={data} variableoptions={variableOptions}/>
                  )}


                  {block.type === "documentBlock" &&(
                    <DocumentEditor nodeid={node} block={block} data={data}/>
                  )}


                  {block.type === "projectBlock" &&(
                    <ProjectEditor nodeid={node} block={block} data={data}/>
                  )}


                  {block.type === "sheetBlock" &&(
                    <SheetEditor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "aiBlock" &&(
                    <AiEditor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "routerBlock" &&(
                    <RouterEditor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "matchBlock" &&(
                    <MatchEditor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "classifyBlock" &&(
                    <ClassifyEditor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "matchV2Block" &&(
                    <MatchV2Editor nodeid={node} block={block} data={data}/>
                  )}

                  {block.type === "loginBlock" &&(
                    <>
                    <LoginEditor nodeid={node} block={block} data={data} language={language}/>
                    {!disclaimer && (
                      <div className="mb-2 mt-2 pointer link" onClick={() => { showDisclaimer(true); }}> + Disclaimer</div>
                    )}
                    {disclaimer && (
                      <>
                        <br />
                        <div>
                          <label htmlFor="disclaimer-login" className="form-label comp-header">
                            Disclaimer
                          </label>
                          <div id="disclaimer-login">
                            <CKEditor
                              config={ckEditorBasic}
                              editor={ClassicEditor}
                              onChange={onEdited}
                              data={disclaimervalue}
                              onBlur={(e, editor) => {
                                handleBlurContent(editor.getData(), 'disclaimer');
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    </>
                  )}
                  
                  {block.type === "calendarBlock" &&(
                    <>
                    <br/><br/>
                    <InputComponent data={data} name="Message" dataname={ language === 'en' ? `headtext_en` : language === 'ru' ? `headtext_ru` : `headtext`} language={language} onBlur={handleBlur}/>

                    <CalendarEditor nodeid={node} block={block} data={data}/>
                    </>
                  )}
                   
                  {block.type === "emailBlock" &&(
                    <>
                    <br/><br/>

                      <InputComponent data={data} name="Subject" dataname={ language === 'en' ? `subject_en` : language === 'ru' ? `subject_ru` : `subject`} language={language} onBlur={handleBlur}/>

                      <div className="section section--with-control">
                        <span>CONTENT DISPLAY MODE</span>
                        <div
                          className="btn-switch"
                          onClick={() => {
                            if (contentDisplayMode === 'html') {
                              Chatbot.setBlockData(block.id, {messageDisplayMode: 'message'});
                              onEdited();
                              return;
                            }
                            const htmlBodyField = handleLocalizedValue('contentHtml');
                            const richField = handleLocalizedValue('content');
                            const patch = {messageDisplayMode: 'html'};
                            const curHtml = data[htmlBodyField];
                            const curRich = data[richField];
                            if (
                              (!curHtml || String(curHtml).trim() === '') &&
                              curRich &&
                              String(curRich).trim() !== ''
                            ) {
                              patch[htmlBodyField] = curRich;
                            }
                            Chatbot.setBlockData(block.id, patch);
                            onEdited();
                          }}
                        >
                          <div
                            className={`switch ${contentDisplayMode === 'html' ? 'on' : 'off'}`}
                          >
                            <span />
                          </div>
                          <span className="text">HTML</span>
                        </div>
                      </div>

                      <div>
                        <div id="content-email">
                          {textBodyIsHtmlMode ? (
                            <>
                              <div className="mode-selector" style={{display: 'flex', gap: '8px', marginBottom: '10px', marginTop: '8px'}}>
                                {['source', 'visual'].map((view) => (
                                  <span
                                    key={view}
                                    className={`mode-pill ${htmlEditorView === view ? 'active' : ''}`}
                                    style={{
                                      padding: '6px 12px',
                                      borderRadius: '4px',
                                      border: '1px solid #ccc',
                                      cursor: 'pointer',
                                      backgroundColor: htmlEditorView === view ? '#032097' : '#f0f0f0',
                                      color: htmlEditorView === view ? 'white' : '#000',
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                      textTransform: 'capitalize',
                                    }}
                                    onClick={() => {
                                      if (view === 'source' && htmlEditorView === 'visual' && htmlVisualRef.current) {
                                        handleBlurContent(htmlVisualRef.current.innerHTML, 'contentHtml');
                                      }
                                      setHtmlEditorView(view);
                                      onEdited();
                                    }}
                                  >
                                    {view}
                                  </span>
                                ))}
                              </div>
                              {htmlEditorView === 'source' ? (
                                <textarea
                                  key={`${block.id}-email-html-src-${language}`}
                                  className="form-control"
                                  rows={6}
                                  placeholder="HTML content"
                                  defaultValue={contentHtmlValue ?? ''}
                                  onChange={onEdited}
                                  onBlur={(e) => {
                                    handleBlurContent(e.target.value, 'contentHtml');
                                  }}
                                />
                              ) : (
                                <div
                                  ref={htmlVisualRef}
                                  className="form-control"
                                  contentEditable
                                  suppressContentEditableWarning
                                  onInput={() => onEdited()}
                                  onBlur={(e) => {
                                    handleBlurContent(e.currentTarget.innerHTML, 'contentHtml');
                                  }}
                                  style={{
                                    minHeight: '120px',
                                    overflow: 'auto',
                                    textAlign: 'left',
                                  }}
                                />
                              )}
                            </>
                          ) : (
                            <CKEditor
                              key={`${block.id}-email-ckeditor-${language}-${contentDisplayMode}`}
                              onReady={() => {}}
                              config={{
                                toolbar: ['bold', 'italic', 'link', 'ctaButton', 'insertImage'],
                                link: {
                                  addTargetToExternalLinks: true,
                                },
                                simpleUpload: {
                                  uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                                },
                              }}
                              onChange={onEdited}
                              editor={ClassicEditor}
                              data={contentvalue ?? ''}
                              onBlur={(e, editor) => {
                                handleBlurContent(editor.getData(), 'content');
                              }}
                            />
                          )}
                        </div>
                      </div>

                      <br/><br/>

                      <EmailEditor nodeid={node} block={block} data={data}/>

                     </>
                  )}

                  
                  {(block.type === "inputBlock" || block.type === "multipleChoiceBlock" || block.type === "uploadBlock" || block.type === "inputuploadBlock" || block.type === "decisionBlock") &&(
                    
                    <InputComponent data={data} name="Validation message" dataname={ language === 'en' ? `validationMessage_en` : language === 'ru' ? `validationMessage_ru` : `validationMessage`} language={language} onBlur={handleBlur}/>

                  )}

                  {(block.type === "inputBlock" || block.type === "uploadBlock" || block.type === "inputuploadBlock" || block.type === "paymentBlock" || block.type === "subscriptionBlock" || block.type === "emailBlock" || block.type === "calendarBlock" || block.type === "matchBlock" || block.type === "matchV2Block" || block.type === "aiBlock" || block.type === "routerBlock" || block.type === "documentBlock" || block.type === "scoroBlock" || block.type === "dataBlock" || block.type === "classifyBlock" || block.type === "conditionBlock" || block.type === "projectBlock") &&(
                     <InputComponent data={data} name="Waiting message" dataname={ language === 'en' ? `waitmessage_en` : language === 'ru' ? `waitmessage_ru` : `waitmessage`} language={language} onBlur={handleBlur}/>
                  )}

                  {WAIT_LADDER_BLOCK_TYPES.has(block.type) && (
                    <>
                      <InputComponent data={data} name={`Waiting message 2 (after ${WAIT_LADDER_THRESHOLDS_SEC[block.type][0]}s)`} dataname={ language === 'en' ? `waitmessage2_en` : language === 'ru' ? `waitmessage2_ru` : `waitmessage2`} language={language} onBlur={handleBlur}/>
                      <InputComponent data={data} name={`Waiting message 3 (after ${WAIT_LADDER_THRESHOLDS_SEC[block.type][1]}s)`} dataname={ language === 'en' ? `waitmessage3_en` : language === 'ru' ? `waitmessage3_ru` : `waitmessage3`} language={language} onBlur={handleBlur}/>
                    </>
                  )}

                  {block.type === "matchV2Block" && (
                    <MatchV2CopiesSection
                      locale={language === 'en' ? 'en' : language === 'ru' ? 'ru' : 'et'}
                    />
                  )}



                  {/* BUTTON */}
                  {(block.type === "inputBlock" || decisionNeedsSubmitButton || block.type === "multipleChoiceBlock" || block.type === "textBlock" || block.type === "shareBlock" || block.type === "paymentBlock" || block.type === "subscriptionBlock" || block.type === "reviewBlock" || block.type === "uploadBlock" || block.type === "inputuploadBlock" || block.type === "calendarBlock" || block.type === "matchBlock" || block.type === "matchV2Block") &&(
                    <>

                      <div className='section'>BUTTON</div>

                      {block.type === 'inputuploadBlock' && !disclaimer && (
                        <div className="mb-2 mt-2 pointer link" onClick={() => { showDisclaimer(true); }}> + Disclaimer</div>
                      )}
                      {block.type === 'inputuploadBlock' && disclaimer && (
                        <>
                          <br />
                          <div>
                            <label htmlFor="disclaimer" className="form-label comp-header">
                              Disclaimer
                            </label>
                            <div id="disclaimer">
                              <CKEditor
                                config={ckEditorBasic}
                                editor={ClassicEditor}
                                onChange={onEdited}
                                data={disclaimervalue}
                                onBlur={(e, editor) => {
                                  handleBlurContent(editor.getData(), 'disclaimer');
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <InputComponent data={data} name="Button name" language={language} dataname={ language === 'en' ? `buttontext_en` : language === 'ru' ? `buttontext_ru` : `buttontext`} onBlur={handleBlur}/>


                      {(block.type === "inputBlock" || block.type === "shareBlock" || block.type === "uploadBlock" || block.type === "inputuploadBlock" || block.type === "calendarBlock" || block.type === "matchBlock" || block.type === "matchV2Block") && (
                        <>
                          <SecondButton />

                          {routeSecondary && (
                            <>
                              <br />
                              <InputComponent data={data} name="Second route" language={language} dataname={ language === 'en' ? `secondbutton_en` : language === 'ru' ? `secondbutton_ru` : `secondbutton`} onBlur={handleBlur}/>
                            </>
                          )}
                        </>
                      )}


                  

                    

                      {block.type === 'textBlock' ? (
                        <>
                        <ButtonState block={block} data={data} startstate={true} dataname="button" label="Active"/>
                        <br/>
                        <ButtonState block={block} data={data} startstate={false} dataname="finish" label="END BLOCK"/>
                        <br/>
                        <ButtonState block={block} data={data} startstate={false} dataname="link" label="LINK"/>
                        {data.link === true && (
                          <>
                            <br/>
                            <InputComponent
                              data={data}
                              name="Button URL"
                              placeholder="https://example.com?x={variable_name}"
                              dataname="buttonUrl"
                              onBlur={handleBlur}
                            />
                            <small style={{fontStyle: 'italic', color: '#666'}}>
                              Use {'{variable_name}'} for chat variables
                            </small>
                          </>
                        )}
                         </>
                      ):(<></>)}  
                       {block.type === 'paymentBlock' ? (
                        <>
                        <ButtonState block={block} data={data} startstate={false} dataname="finish" label="END"/>
                         </>
                      ):(<></>)}  

                    </>       
                  )}

                  {/* DATA */}
                  {(block.type === "inputBlock" || block.type === "decisionBlock" || block.type === "multipleChoiceBlock" || block.type === "shareBlock" || block.type === "uploadBlock" || block.type === "calculationBlock" || block.type === "aiBlock") &&(
                    <>
                      <div className='section'>DATA</div>
                      {block.type === "aiBlock" ? (
                        // For AI block, only show Variable field when in single mode (outputMode === 'single' or no outputMode with empty mappings)
                        (data?.outputMode !== 'multiple' || (!data?.outputMode && (!data?.outputMappings || data.outputMappings.length === 0))) && (
                          <InputComponent icon="*" data={data} name="Variable" dataname="variable" onBlur={handleBlur}/>
                        )
                      ) : (
                        // For other blocks, always show Variable field
                        <InputComponent icon="*" data={data} name="Variable" dataname="variable" onBlur={handleBlur}/>
                      )}
                    </>
                  )}


              </div>
              )}
              
            
                
                
              
          
    </>
    )

}